// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Background-wrap","inner":"Background-inner"};